import { FormSection } from '@ksyos/design-system';
import { NarrowerTextInputWithUnitsFormGroup } from '../../../processActivityFormGroupFields';

export function UseFormSection(props: Readonly<{ fieldKey: string }>) {
    return (
        <FormSection title="Gebruik">
            <NarrowerTextInputWithUnitsFormGroup
                fieldKey={`${props.fieldKey}NightsWithSupport`}
                label="Nachten met ondersteuning"
            />

            <NarrowerTextInputWithUnitsFormGroup
                fieldKey={`${props.fieldKey}AverageUse`}
                label="Gemiddeld gebruik"
                units="uur / nacht"
            />
        </FormSection>
    );
}
